export enum MqttClientType {
    DEVICE = "DEVICE",
    APP = "APP",
    SERVER = "SERVER"
}

export const mqttClientTypeZh =
    {
        DEVICE: "设备端",
        APP: "应用端",
        SERVER: "服务端"
    }
